import { useState } from 'react'

/**
 * A text field's value that follows the server's.
 *
 * Seeded from the server's value, and updated when that value changes (a save,
 * or another admin's change arriving on refetch) — unless the person has typed
 * something different, which is kept. Without this a field shows the value it
 * first loaded, and Save would write it back over a newer one.
 *
 * Adjusting state during render is React's documented way to follow a prop.
 */
export function useSyncedText(
  server: string,
): [string, (text: string) => void] {
  const [text, setText] = useState(server)
  const [seen, setSeen] = useState(server)
  if (server !== seen) {
    setSeen(server)
    if (text === seen) setText(server)
  }
  return [text, setText]
}
